<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="idsPeriodicidades"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
